import { Component, OnInit, forwardRef } from '@angular/core';
import { NavController, NavParams, AlertController, ModalController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { UserProvider } from 'src/app/services/user/user';
import { LoginPage } from 'src/app/pages/login/login.page';
import { Browser } from '@capacitor/browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SemRegistroComponent } from '../sem-registro/sem-registro';
import { SafeHtmlPipe } from 'src/app/pipes/safe-html/safe-html';
import { CultoDetalhesPage } from 'src/app/pages/culto/culto-detalhes/culto-detalhes.page';
import { EventoDetalhesPage } from 'src/app/pages/evento/evento-detalhes/evento-detalhes.page';
import { EnqueteListaPage } from 'src/app/pages/enquete-lista/enquete-lista.page';

@Component({
  selector: 'app-noticia-links',
  templateUrl: './noticia-links.page.html',
  styleUrls: ['./noticia-links.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SemRegistroComponent,
    TranslateModule,
    SafeHtmlPipe
  ],
})
export class NoticiaLinksPage implements OnInit {
  links: any = [];
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    public translate: TranslateService,
    public modalCtrl: ModalController,
    public userProvider: UserProvider,
  ) {
    this.links = navParams.get('links');
  }

  ngOnInit() {}

  async needLogin() {
    let alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant('Necessário Login'),
      message: this.translate.instant('Para utilizar essa funcionalidade é necessário fazer login'),
      buttons: [
        {
          text: this.translate.instant('Cancelar'),
          handler: () => { }
        },
        {
          text: this.translate.instant('Fazer Login'),
          handler: async () => {
            const modalPage = await this.modalCtrl.create({ component: LoginPage, componentProps: { 'mostrarHeader': true } });
            modalPage.present();
          }
        }
      ]
    });

    alert.present();
  }

  public async openLink(link: { target: string; url: any; config: string; }) {
    if (link.target == '_blank') {
      await Browser.open({ url: link.url });
    } else if (link.target == '_system') {
      await window.open( link.url );
    } else if (link.target == 'contribua') {
      let contribua: any = JSON.parse(link.config);
      await Browser.open({ url: contribua.link });

    } else if (link.target == 'culto') {
      this.userProvider.isLoggedin().then(async login => {
        if (this.userProvider.isAnonimo() || !login) {
          this.needLogin();
        } else {
          let culto: any = JSON.parse(link.config);
          let data = { idCulto: culto.idCulto, dataInicio: culto.dataInicio, idCultoAgenda: culto.idCultoAgenda, modal: false };
          const modalPage = await this.modalCtrl.create({ component: CultoDetalhesPage, componentProps: data });
          modalPage.present();
        }
      });
    } else if (link.target == 'evento') {
      this.userProvider.isLoggedin().then(async login => {
        if (this.userProvider.isAnonimo() || !login) {
          this.needLogin();
        } else {
          let evento: any = JSON.parse(link.config);
          var data = { id: evento.idEvento }
          const modalPage = await this.modalCtrl.create({ component: EventoDetalhesPage, componentProps: data });
          modalPage.present();
        }
      });

    } else if (link.target == 'enquete') {
      this.userProvider.isLoggedin().then(async login => {
        if (this.userProvider.isAnonimo() || !login) {
          this.needLogin();
        } else {
          const modalPage = await this.modalCtrl.create({ component: EnqueteListaPage });
          modalPage.present();
        }
      });

    }
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
